// Full-document render of the Oscar order-pending ("order error") view:
// PageSkeleton (the React document shell) wrapping OrderPendingBody, plus the
// deferred GA4 dataLayer events (ga_ecom) and the Google Seller Ratings survey
// opt-in (ga_seller; the legacy page fired no ga_purchase -- payment did not
// complete). Header/footer slots are omitted so the default site chrome
// renders.
import React from "react";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";
import { GASeller } from "tsi-common-react/src/components/GASeller/index";

import { templates } from "@reactivated";

import { OrderPendingBody } from "../components/OrderPendingBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderPendingDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <OrderPendingBody {...props} />
            <DataLayerPush events={props.ga_events} />
            <GASeller surveyData={props.ga_seller_survey_data} />
        </PageSkeleton>
    );
};
